import types from '../mutations/mutation-types'
import Api from '../../../utils/api'

export default {
  addMessage ({ commit }, message) {
    commit(types.NUDGE.ADD_MESSAGE, message)
  },
  removeMessage ({ commit }, key) {
    commit(types.NUDGE.REMOVE_MESSAGE, key)
  },
  async queryUser ({ commit }, config) {
    try {
      const { status, data: { payload } } = await Api.buildRequest('nudge/users', 'GET', config)
      if (status === 200) {
        commit(types.NUDGE.QUERY_RESULT, payload.users)
      } else {
        commit(types.NUDGE.RESULT_MESSAGE, {
          type: 'error',
          text: payload.error
        })
      }
    } catch (error) {
      commit(types.NUDGE.RESULT_MESSAGE, {
        type: 'error',
        text: 'An unknown error occurred'
      })
    }
  },
  async nudgeUsers ({ commit, state }, config) {
    // get the messages from the store
    const nudgeData = { ...config, message: state.messages }
    try {
      const { status, data: { payload } } = await Api.buildRequest(`nudge`, 'POST', nudgeData)
      if (status === 200) {
        commit(types.NUDGE.RESULT_MESSAGE, {
          type: 'success',
          text: 'Nudge successfully created'
        })
      } else {
        commit(types.NUDGE.RESULT_MESSAGE, {
          type: 'error',
          text: payload.error
        })
      }
    } catch (error) {
      commit(types.NUDGE.RESULT_MESSAGE, {
        type: 'error',
        text: 'An unknown error occurred'
      })
    }
  },
  async getAllNudges ({ commit }) {
    const { status, data: { payload } } = await Api.buildRequest(`nudge`, 'GET')
    if (status === 200) {
      commit(types.NUDGE.LOAD_NUDGES, payload)
    }
  },
  async getANudgeDetails ({ commit }, nudgeId) {
    const { status, data: { payload } } = await Api.buildRequest(`nudge/${nudgeId}`, 'GET')
    if (status === 200) {
      commit(types.NUDGE.LOAD_A_NUDGE_STATS, payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/nudge.js